import { render, staticRenderFns } from "./Sertificate.vue?vue&type=template&id=6b74c22c&scoped=true&"
import script from "./Sertificate.vue?vue&type=script&lang=js&"
export * from "./Sertificate.vue?vue&type=script&lang=js&"
import style0 from "./Sertificate.vue?vue&type=style&index=0&id=6b74c22c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b74c22c",
  null
  
)

export default component.exports